import React from 'react'
import MaterialTable from '@material-table/core'
import HeaderComponent from 'components/HeaderComponent'
import Icons from 'includes/Icons'
import { withTranslation } from 'react-i18next'
import { UilPlus } from '@iconscout/react-unicons'
import useSWR, { mutate } from 'swr'
import { useDispatch, useSelector } from 'react-redux'
import CreateSchedule from './CreateSchedule'
import { getResponse, showModal } from 'store/slices/miscSlice'
import TableActionBtn from 'components/TableActionBtn'
import { apiRequest } from 'store/Misc/apiRequest'
import Spinner from 'components/Spinner'
import { withRouter } from 'hooks/withRouter'
import { useEffect } from 'react'

export default withTranslation()(withRouter(function Schedules({ t }) {
  const { data: schedules } = useSWR('promos/schedules')
  const dispatch = useDispatch()
  const deleteSchedule = async (id) => {
    await apiRequest({
      url: `promos/schedules/${id}`,
      method: 'delete',
    })
    dispatch(getResponse(`delete_${id}`))
  }
  const { response } = useSelector(state => state?.misc)
  useEffect(() => {
    mutate('promos/schedules')
  }, [response])
  return (
    <div className="w-full bg-white p-5 rounded-lg">
      {
        schedules ? <MaterialTable
          columns={[
            {
              title: t('settings.schedules.table.day'),
              field: 'day'
            },
            {
              title: t('settings.schedules.table.from'),
              field: 'from',
              render: ({ from }) => <>{`${from.name_12} (${from.name_24})`}</>
            },
            {
              title: t('settings.schedules.table.to'),
              field: 'to',
              render: ({ to }) => <>{`${to.name_12} (${to.name_24})`}</>
            },
          ]}
          actions={[
            {
              icon: 'save',
              tooltip: 'Save User',
            },
          ]}
          options={{
            actionsColumnIndex: -1
          }}
          icons={Icons}
          data={schedules?.data ?? []}
          components={{
            Toolbar: props => (
              <div className="border-b pb-5 mb-5">
                <HeaderComponent
                  title="Schedules"
                  btnText={() => <><UilPlus size={20} className="mr-2" /> Add schedule</>}
                  btnClick={() => dispatch(
                    showModal({
                      title: t('promo.schedules.title'),
                      content: CreateSchedule,
                      url: 'promos/schedules',
                      method: 'post',
                      formClass: 'w-11/12 md:w-[390px]',

                      // validation: POSValidation
                    })
                  )
                  }
                />
              </div>
            ),
            Action: ({ data }) => (
              <>
                <TableActionBtn
                  data={[
                    {
                      Content: {
                        icon: '',
                        text: <span className='text-danger'>Delete schedule</span>
                      },
                      action: (id) => { deleteSchedule(data.id) }
                    }
                  ]}
                />
              </>
            ),
            // Pagination: ({data}) => (
            //   <>
            //     <Paginator />
            //   </>
            // )
          }}
        /> : <Spinner />
      }
    </div>
  );
}))
